
import 'reset.scss/reset.scss'

import 'slick-carousel/slick/slick.scss'
import 'slick-carousel/slick/slick-theme.scss'

import 'smartphoto/scss/smartphoto.scss'

import './scss/style.scss'

import $ from 'jquery'
import SmartPhoto from 'smartphoto'
import slick from 'slick-carousel'

import jqueryJpostal from 'jquery-jpostal-ja'

$(function () {

  /**
   * 内観のスライダー
   */

  $("#slick-room").on("init", function (event, slick) {
    $(this).append(
      '<div class="slider-num"><span class="now-count"></span><span class="count-seperate">/</span><span class="all-count"></span></div>'
    )
    $(".now-count").text(slick.currentSlide + 1)
    $(".all-count").text(slick.slideCount)
  }).slick({
    autoplay: false
  }).on("beforeChange", function (event, slick, currentSlide, nextSlide) {
    $(".now-count").text(nextSlide + 1)
  })

  /**
   * 周辺環境のスライダー
   */

  $('#slick-map').slick({
    autoplay: false,
    slidesToShow: 3,
    responsive: [{
      breakpoint: 641,
      settings: {
        slidesToShow: 1
      }
    }]
  })

  /**
   * お部屋の特徴・概要のタブ
   */

  $('.js-spec-tab').on('click', function(){
    const targetArea = $(this).data('target')

    $('.spec-tabs .spec-tab').removeClass('is-current')
    $(this).addClass('is-current')
    
    $('.spec-tab-main .tab-content').hide()
    if(targetArea !== undefined){
      $(`#${targetArea}`).show()
    } else {
      $('.spec-tab-main .tab-content').show()
    }
  })

  /**
   * 住所の自動入力
   */

  $('#postcode1').jpostal({
    click: '#js-postal',
    postcode : [
      '#postcode1'
    ],
    address : {
      '#pref'  : '%3',
      '#address2'  : '%4%5'
    }
  });

})

/**
 * smartPhotoの設定
 */

window.addEventListener('DOMContentLoaded', function () {
  new SmartPhoto(".js-smartPhoto", {
    nav: true
  })
})